<div style="display: flex; height: 100%;">
  <div style="display: flex; overflow: auto; width: 100%;">
    <div style="display: flex; flex-direction: column; margin: 20px auto; z-index: 1; width: 50%;">
      <mat-toolbar color="primary" class="toolbar-over-card" style="padding: 20px; align-items: center; justify-content: space-between;">
        <!-- Title -->
        <div><span>{{config?.title}} Field Editor</span></div>

        <div style="display: flex; font-size: medium; align-items: center;">
          <button (click)="toggleExpandCollapse()" mat-button aria-label="Add Field">
            <div class="fal fa-arrows-from-line" style="font-size: 18px; margin-right: 10px;"></div>
            <span>Expand / Collapse</span>
          </button>
          <button (click)="add()" mat-button aria-label="Add Field">
            <div class="fal fa-plus" style="font-size: 18px; margin-right: 10px;"></div>
            <span>Add Field</span>
          </button>
          <button *ngIf="!config?.disableMenu" mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="fileUpload.click()">
              <mat-icon>file_upload</mat-icon>
              Import
            </button>
          </mat-menu>
          <input type="file" class="file-input" (change)="import($event)" style="display: none" #fileUpload>
        </div>
      </mat-toolbar>
      <mat-card appearance="outlined" class="card-under-toolbar" style="display: flex;" [formGroup]="fieldFormGroup">
        <mat-card-content style="flex: auto; display: flex; flex-direction: column; gap: 10px;">
          <div id="list-1" cdkDropList cdkDropListGroup [cdkDropListAutoScrollDisabled]="false" [cdkDropListData]="null" (cdkDropListDropped)="dropSection($event)" >
            <div *ngFor="let field of fields" cdkDragLockAxis="y"  cdkDragPreviewClass="field-node-dragging" cdkDrag [cdkDragData]="field" style="margin-bottom: 10px;">
              <div  *ngIf="field.nodeType === 'section'" class="field-node-section" (click)="field.expanded = !field.expanded" >
                <div style="display: flex; gap:15px; align-items: center">
                  <div *ngIf="!field.expanded" class="fal fa-chevron-down" style="font-size: 18px; cursor: pointer;"></div>
                  <div *ngIf="field.expanded" class="fal fa-chevron-up" style="font-size: 18px; cursor: pointer;"></div>
                  <div *ngIf="!field.isEditing" style="font-size: 16px;">{{field.label}}</div>
                  <div *ngIf="field.isEditing">
                    <mat-form-field class="full-width" appearance="fill" (click)="$event.stopPropagation()">
                      <mat-label>Field Label</mat-label>
                      <input (mousedown)="$event.stopPropagation()"  matInput placeholder="Field Label" formControlName="field-{{field.id}}"/>
                    </mat-form-field>
                  </div>
                </div>
                <div *ngIf="!field.isEditing" style="display: flex; gap:15px;">
                  <div (mousedown)="$event.stopPropagation();" (click)="startEdit($event, field);" style="display:flex; gap: 10px; cursor: pointer;">
                    <div class="fal fa-pen-to-square" style="font-size: 18px;"></div>
                    <span class="text action-text">Edit</span>
                  </div>
                  <div (mousedown)="$event.stopPropagation();" (click)="delete($event, field)" style="display:flex; gap: 10px; cursor: pointer;">
                    <div class="fal fa-trash-can" style="font-size: 18px; color: #FF0000"></div>
                    <span class="text action-text">Remove</span>
                  </div>
                </div>
                <div *ngIf="field.isEditing" style="display: flex; gap:15px; cursor: pointer;">
                  <div (mousedown)="$event.stopPropagation();" (click)="stopEdit($event, field)" style="display:flex; gap: 10px;">
                    <div class="fal fa-check" style="font-size: 18px; color: #25c748"></div>
                    <span class="text action-text">Save</span>
                  </div>
                  <div (mousedown)="$event.stopPropagation();" (click)="cancelEdit($event, field)" style="display:flex; gap: 10px; cursor: pointer;">
                    <div class="fal fa-x" style="font-size: 18px; color: #FF0000"></div>
                    <span class="text action-text">Cancel</span>
                  </div>
                </div>
              </div>
              <div class="field-node-section-items" id='list-{{field.id}}' *ngIf="field.expanded" cdkDropList [cdkDropListAutoScrollDisabled]="false" (cdkDropListDropped)="dropNode($event)" [cdkDropListData]="field">
                <div *ngFor="let child of field?.items" cdkDrag cdkDragLockAxis="y" cdkDragPreviewClass="field-node-dragging" [cdkDragData]="child" style="padding-top: 3px;">
                  <div *ngIf="child.nodeType === 'node'" class="field-node">
                    <div style="display: flex; gap:15px; align-items: center;">
                      <div matTooltip="Checkbox" *ngIf="child.type === 'checkbox'" class="fal fa-check-to-slot" style="font-size: 18px;"></div>
                      <div matTooltip="Text Input" *ngIf="child.type === 'input'" class="fal fa-input-text" style="font-size: 18px;"></div>
                      <div matTooltip="Shared Checkbox" *ngIf="child.type === 'shared-checkbox'" class="fal fa-user-check" style="font-size: 18px;"></div>
                      <div *ngIf="!child.isEditing" class="text child-label" style="font-size: 16px;">
                        {{child.label}}
                      </div>
                      <div *ngIf="child.isEditing" style="display: flex; gap:15px; align-items: center">
                          <mat-form-field class="full-width" appearance="fill">
                            <mat-label>Field Label</mat-label>
                            <input (mousedown)="$event.stopPropagation()" matInput placeholder="Field Label" formControlName="field-{{child.id}}">
                          </mat-form-field>
                      </div>
                    </div>
                    <div *ngIf="!child.isEditing"  style="display: flex; gap:15px;">
                      <div (mousedown)="$event.stopPropagation();" (click)="startEdit($event, child)" style="display:flex; gap: 10px; cursor: pointer;">
                        <div class="fal fa-pen-to-square" style="font-size: 18px;"></div>
                        <span class="text action-text">Edit</span>
                      </div>
                      <div (mousedown)="$event.stopPropagation()" (click)="delete($event, child)" style="display:flex; gap: 10px; cursor: pointer;">
                        <div class="fal fa-trash-can" style="font-size: 18px; color: #FF0000"></div>
                        <span class="text action-text">Remove</span>
                      </div>
                    </div>
                    <div *ngIf="child.isEditing"style="display: flex; gap:15px;">
                      <div (mousedown)="$event.stopPropagation()" (click)="stopEdit($event, child)" style="display:flex; gap: 10px; cursor: pointer;">
                        <div class="fal fa-check" style="font-size: 18px; color: #25c748"></div>
                        <span class="text action-text">Save</span>
                      </div>
                      <div (mousedown)="$event.stopPropagation()" (click)="cancelEdit($event, child)" style="display:flex; gap: 10px; cursor: pointer;">
                        <div class="fal fa-x" style="font-size: 18px; color: #FF0000"></div>
                        <span class="text action-text">Cancel</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
